import {
  UpdateNotificationsSettingsCommand,
  type UpdateNotificationsSettingsCommandInput,
  type UpdateNotificationsSettingsResponse,
} from '@perfectpost/perfect-post-common';
import {useMutation, useQueryClient} from '@tanstack/react-query';

import {sendOrThrow} from '../../../services/sendOrThrow';
import {notificationKeys} from '../keys';
import type {MutationUiOptions} from '../../../utils/mutationMeta';

/**
 * Enregistre les réglages d'e-mails.
 *
 * Remplace les `send(new UpdateNotificationsSettingsCommand(…))` de `Profile`
 * (à chaque interrupteur) et de `LoginRequiredRoute` (dialogue de premier
 * réglage). Les composants gardent leur copie locale pour l'affichage immédiat.
 */
export function useUpdateNotificationsSettingsMutation(options: MutationUiOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationKey: [...notificationKeys.mutations(), 'update'],
    mutationFn: (input: UpdateNotificationsSettingsCommandInput): Promise<UpdateNotificationsSettingsResponse> =>
      sendOrThrow(new UpdateNotificationsSettingsCommand(input)),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: notificationKeys.settings()});
    },
  });
}
